module.exports = __webpack_public_path__ + "img/package.d314da85.png";